import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_g39ej8ubtw: FaireBrandEntity = {
  token: "b_g39ej8ubtw",
  type: "brand",
  name: "Morxy LLC",
  avatarUrl:
    "https://cdn.faire.com/fastly/71ec72951145e68807958828bf6e40faea8da49a50183f1ee991c8e3cc89c21a.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/e36b97acf8d840c531b2d0f281a889d9db298c4878c3fd7be95c27e50c93b4eb.png",
  logoUrl:
    "https://cdn.faire.com/fastly/71ec72951145e68807958828bf6e40faea8da49a50183f1ee991c8e3cc89c21a.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e36b97acf8d840c531b2d0f281a889d9db298c4878c3fd7be95c27e50c93b4eb.png",
  location: "San Antonio, TX, USA",
  minimumOrderDollars: 80,
  rating: 5,
  reviewCount: 10,
  isTopShop: true,
  isInsider: true,
  description:
    "Morxy is a family owned business located in San Antonio Texas. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:56.337Z",
    importedBy: "entity-db-cli",
  },
};
